// Texty rychlého náhledu produktu z upsellu na detailu (upsellQuickView.js).
export default {
  title: 'Rychlý náhled',
  closeLabel: 'Zavřít',
  doneLabel: 'Zavřít',
  pageLabel: 'Celý detail produktu',
  loading: 'Načítáme informace o produktu…',
  error: 'Podrobnosti se teď nepodařilo načíst.',
  add: 'Přidat k objednávce',
  added: 'Přidáno k objednávce',
  variant: 'Vybrat variantu na detailu',
  params: 'Parametry',
  paramsAll: 'Všechny parametry',
  rating: 'hodnocení',
  delivery: 'Doručíme',
  photo: 'Fotka',
};
